import { useAuth0 } from 'Auth';

export type AgentPortalRoles = {
  hasAgentRole: boolean;
  hasPrincipalRole: boolean;
  roleNames: Set<string>;
};

/**
 * Derives agent portal role membership from the authenticated user's
 * portalUserGrants. Role names are read from currentUser at Auth0 session boot
 * (no caching — satisfies real-time role-check requirements).
 */
export const useAgentPortalRoles = (): AgentPortalRoles => {
  const { user } = useAuth0();

  const roleNames = new Set<string>(
    (user?.portalUserGrants ?? [])
      .map((grant) => grant.role?.name)
      .filter(
        (name): name is string => typeof name === 'string' && name.length > 0
      )
  );

  return {
    hasAgentRole: roleNames.has('agent'),
    hasPrincipalRole: roleNames.has('principal'),
    roleNames,
  };
};
